import React from 'react';

import dayjs from 'dayjs';

import CustomModal from 'components/CustomModal/CustomModal';

import { Button } from 'components/Button';

import { formatFloating } from 'utils/formatters/timezone';

import { ConfirmError } from '../styles';

import { SendError } from '../types';

import SkippedRecipientsList from './SkippedRecipientsList';

interface SendConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  dueDate: string | null;
  recipientCount: number;
  sending: boolean;
  countLoading?: boolean;
  isEstimate?: boolean;
  sendError?: SendError | null;
}

const recipientTitle = (count: number, loading: boolean, isEstimate: boolean): string => {
  if (loading) return 'Counting recipients…';
  if (isEstimate) return `Send to about ${count} recipients?`;
  return `Send to ${count} recipient${count === 1 ? '' : 's'}?`;
};

const SendConfirmModal: React.FunctionComponent<SendConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  dueDate,
  recipientCount,
  sending,
  countLoading = false,
  isEstimate = false,
  sendError = null,
}) => {
  const formattedDueDate = dueDate ? formatFloating(dayjs(dueDate).format('YYYY-MM-DD'), 'date') : '';

  return (
    <CustomModal
      openModal={open}
      onClose={sending ? undefined : onClose}
      modalTitle={recipientTitle(recipientCount, countLoading, isEstimate)}
      modalDescription={`Each recipient will receive an email with a link to acknowledge by ${formattedDueDate}.`}
      cancelButton={
        <Button variant="outlined" size="large" onClick={onClose} disabled={sending}>
          Back
        </Button>
      }
      submitButton={
        <Button
          variant="contained"
          size="large"
          onClick={onConfirm}
          disabled={sending || countLoading || sendError !== null}
        >
          Send
        </Button>
      }
    >
      {sendError ? (
        <>
          <ConfirmError>{sendError.message}</ConfirmError>
          <SkippedRecipientsList skipped={sendError.skipped} />
        </>
      ) : null}
    </CustomModal>
  );
};

export default SendConfirmModal;
